import { pxToRem } from '../../../../utils';
export default (function (siteVariables) {
  return {
    borderColor: undefined,
    borderWidth: 2,
    iconSize: pxToRem(7),
    successBackgroundColor: siteVariables.colorScheme.green.background,
    successTextColor: siteVariables.colorScheme.green.foreground1,
    infoBackgroundColor: siteVariables.colorScheme.brand.background,
    infoTextColor: siteVariables.colorScheme.default.foreground2,
    warningBackgroundColor: siteVariables.colorScheme.yellow.background,
    warningTextColor: siteVariables.colorScheme.yellow.foreground2,
    errorBackgroundColor: siteVariables.colorScheme.red.background,
    errorTextColor: siteVariables.colorScheme.red.foreground2,
    defaultBackgroundColor: siteVariables.colorScheme.default.background5,
    defaultTextColor: siteVariables.colorScheme.default.foreground4
  };
});
//# sourceMappingURL=statusVariables.js.map
